import { Injectable } from '@angular/core';
import { Urls } from '../utilities/urls.component';
import { HttpHeadersService } from './http-headers.service';

import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { TransactionDetailsResponseDTO } from '../models/TransactionDetailsResponseDTO';
import { TransactionRequestDTO } from '../models/TransactionRequestDTO';
import { TransactionResponseDTO } from '../models/TransactionResponseDTO';

@Injectable()
export class TransactionsService {

   subject = new Subject();

  // API_ENDPOINT:string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {
    // this.API_ENDPOINT=localStorage.getItem("ENDPOINT");
  

  }


  getTransactionsList(request: TransactionRequestDTO) {
    var url: string = Urls.API_V2_ENDPOINT + Urls.TRANSACTIONS.getAllTransacton;
    return this.http.post<TransactionResponseDTO>(url, request, this.headers.getCommonHttpHeaders('v2_api')).pipe(timeout(6000000));
  }

  getTransactionById(request: TransactionRequestDTO) {
    var url: string = Urls.API_ENDPOINT + Urls.TRANSACTIONS.getTransactionById;
    return this.http.post<TransactionDetailsResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  exportTransaction(request: TransactionRequestDTO) {
    var url: string = Urls.API_ENDPOINT + Urls.EXPORTAS.transactionExcelExport;
    return this.http.post<any>(url, request, this.headers.getCommonHttpHeaders());
  }
  getTransactionsListById(request: TransactionRequestDTO){
    var url: string = Urls.API_ENDPOINT + Urls.TRANSACTIONS.getTransacionListById;
    return this.http.post<TransactionResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    }
    getTransactionsListInByteArray(request: TransactionRequestDTO) {
      var url: string = Urls.API_ENDPOINT + Urls.TRANSACTIONS.downloadxlsx;
      return this.http.post<TransactionResponseDTO>(url, request,{responseType: 'blob' as 'json'},
      
      );
    }
    getExportDataOnTransaction(request: TransactionRequestDTO) {
      var url: string = Urls.API_V2_ENDPOINT + Urls.TRANSACTIONS.getExportDataOnTransaction;
      return this.http.post<TransactionResponseDTO>(url, request, this.headers.getCommonHttpHeaders('v2_api'));
    }
  

}
